import { render, staticRenderFns } from "./MgmProductItem.vue?vue&type=template&id=05c7b5c3&scoped=true&"
import script from "./MgmProductItem.vue?vue&type=script&lang=js&"
export * from "./MgmProductItem.vue?vue&type=script&lang=js&"
import style0 from "./MgmProductItem.vue?vue&type=style&index=0&id=05c7b5c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c7b5c3",
  null
  
)

export default component.exports